export const BUTTON_PRESS = 'Button Press:'
export const TAB_PRESS = 'Tab Press:'
export const VIEW = 'View:'
export const PAGE_LOAD = 'Page Load:'
export const TOGGLE = 'Toggle:'
